'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _magicVirtualElement = require('magic-virtual-element');

var _magicVirtualElement2 = _interopRequireDefault(_magicVirtualElement);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var propTypes = {
	class: {
		type: 'string'
	},
	items: {
		type: 'array'
	}
}; /** @jsx dom */


function render(_ref) {
	var props = _ref.props;
	var items = props.items;


	function getItems() {
		return items.map(function (el) {
			return (0, _magicVirtualElement2.default)(
				'li',
				{ 'class': 'Breadcrumbs-item' },
				(0, _magicVirtualElement2.default)(
					'a',
					{ href: el.url },
					el.label
				)
			);
		});
	}

	return (0, _magicVirtualElement2.default)(
		'ul',
		{ 'class': ['Breadcrumbs', props.class] },
		getItems()
	);
}

exports.default = { propTypes: propTypes, render: render };